import React from 'react';
import { Button, TextField } from '@mui/material';
import { Search, Settings } from '@mui/icons-material';
import { Col, Row } from 'antd';
import Loading from 'components/Loading';
import styled from 'styled-components';

const WrapperForm = styled.form`
    padding: 40px 0px;
    width: 100%;
`;

const SearchForm = ({
    title = "User Search",
    searchValue,
    onSearchChange,
    onSubmit,
    loading = false,
    searchLabel = "First name or last name",
    showManageKeys = false,
    manageKeysPath = "",
    onManageKeysClick,
    additionalFields = [],
    searchButtonText = "Search"
}) => {
    return (
        <div style={{
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            borderRadius: '16px',
            padding: '24px',
            marginBottom: '24px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
            border: '1px solid #dee2e6'
        }}>
            <div style={{
                fontSize: '20px',
                fontWeight: '700',
                color: '#495057',
                marginBottom: '20px',
                textAlign: 'center',
                textTransform: 'uppercase',
                letterSpacing: '1px'
            }}>
                {title}
            </div>
            
            <WrapperForm onSubmit={onSubmit}>
                <Row className="fixAdminInput" gutter={[16, 16]} style={{ alignItems: 'center' }}>
                    {additionalFields.map((field, index) => (
                        <React.Fragment key={index}>
                            {field.component}
                            {field.separator && (
                                <Col span={1} style={{ textAlign: 'center', fontSize: '14px', fontWeight: '500', color: '#6c757d' }}>
                                    {field.separator}
                                </Col>
                            )}
                        </React.Fragment>
                    ))}
                    
                    <Col span={8}>
                        <TextField
                            id="name"
                            name="name"
                            label={searchLabel}
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            variant="outlined"
                            onChange={onSearchChange}
                            value={searchValue}
                            style={{ width: '100%' }}
                            InputProps={{
                                style: {
                                    height: '40px',
                                    fontSize: '14px',
                                    borderRadius: '8px'
                                }
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '&:hover fieldset': {
                                        borderColor: '#007bff',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#007bff',
                                    },
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: '#007bff',
                                }
                            }}
                        />
                    </Col>

                    <Col>
                        <Button 
                            disabled={loading} 
                            variant="contained" 
                            color="primary" 
                            type="submit"
                            style={{
                                height: '40px',
                                padding: '0 20px',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontWeight: '600',
                                textTransform: 'none',
                                background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                boxShadow: '0 4px 12px rgba(0, 123, 255, 0.3)',
                                border: 'none',
                                minWidth: '100px',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #0056b3 0%, #004085 100%)',
                                    boxShadow: '0 6px 16px rgba(0, 123, 255, 0.4)'
                                }
                            }}
                        >
                            {loading ? <Loading size={16} white /> : searchButtonText}
                            <Search style={{ height: '16px', margin: '0px 0px 0px 6px', width: '16px' }} />
                        </Button>
                    </Col>

                    {showManageKeys && (
                        <Col>
                            <Button 
                                variant="contained" 
                                startIcon={<Settings style={{color:"#fff" , fontSize:14}}/>} 
                                style={{ 
                                    height: '40px',
                                    padding: '0 16px',
                                    borderRadius: '8px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    textTransform: 'none',
                                    background: 'linear-gradient(135deg, #6c757d 0%, #495057 100%)',
                                    boxShadow: '0 4px 12px rgba(108, 117, 125, 0.3)',
                                    border: 'none',
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #495057 0%, #343a40 100%)',
                                        boxShadow: '0 6px 16px rgba(108, 117, 125, 0.4)'
                                    }
                                }} 
                                onClick={onManageKeysClick}
                            >
                                Manage Keys
                            </Button>
                        </Col>
                    )}
                </Row>
            </WrapperForm>
        </div>
    );
};

export default SearchForm;
